
<ng-container *ngIf="isLoggedIn && !isEmpresaPage">
<!-- Backdrop -->
<div class="chatF__backdrop" *ngIf="chatOpen" (click)="closeChat()"></div>

<!-- Panel del chat -->
<div class="chatF__panel" [class.chatF__panel--open]="chatOpen">

  <!-- Header -->
  <div class="chatF__header">
    <div class="chatF__headerLeft">
      <div class="chatF__avatar">
        <svg width="18" height="18" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff" opacity="0.9"/>
        </svg>
      </div>
      <div>
        <div class="chatF__name">Asistente TritanIA</div>
        <div class="chatF__status">
          <span class="chatF__dot"></span>
          En línea · IA activa
        </div>
      </div>
    </div>
    <button class="chatF__close" type="button" (click)="closeChat()">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
        <path d="M18 6L6 18M6 6l12 12"/>
      </svg>
    </button>
  </div>

  <!-- Sugerencias -->
  <div class="chatF__suggestions">
    <span class="chatF__sugLabel">Sugerencias rápidas</span>
    <div class="chatF__chips">
      <button class="chatF__chip" type="button" (click)="askAI('¿Qué lugares me recomiendas en el Quindío?')">📍 Lugares top</button>
      <button class="chatF__chip" type="button" (click)="askAI('Plan de aventura en el Quindío')">🏔️ Aventura</button>
      <button class="chatF__chip" type="button" (click)="askAI('¿Qué comer en el Quindío?')">🍽️ Gastronomía</button>
    </div>
  </div>

  <!-- Mensajes -->
  <div class="chatF__messages" #chatBox>
    <div *ngFor="let msg of chatMessages" class="chatF__msg" [class.chatF__msg--user]="msg.role==='user'" [class.chatF__msg--ai]="msg.role==='ai'">
      <div *ngIf="msg.role==='ai'" class="chatF__msgAvatar">
        <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff"/>
        </svg>
      </div>
      <div class="chatF__bubble" [class.chatF__bubble--user]="msg.role==='user'">
  {{ msg.text }}
  <div *ngIf="msg.lugares?.length" class="chatF__lugares">
    
    <div 
      class="chatF__lugarCard"
      *ngFor="let lugar of msg.lugares"
      (click)="irALugar(lugar)"
    >
      <div class="chatF__lugarNombre">
        <span class="chatF__iconLugar"></span><i class="fa-solid fa-location-dot"></i>  {{ lugar.nombre_establecimiento }}
      </div>
      <div class="chatF__lugarTipo">
        <i class="fa-solid fa-tag"></i>{{ lugar.nombre_tipo }}
      </div>
    </div>

  </div>
</div>
    </div>
    <div *ngIf="aiLoading" class="chatF__msg chatF__msg--ai">
      <div class="chatF__msgAvatar">
        <svg width="12" height="12" fill="none" viewBox="0 0 24 24">
          <path d="M12 2L13.5 8.5L20 10L13.5 11.5L12 18L10.5 11.5L4 10L10.5 8.5L12 2Z" fill="#fff"/>
        </svg>
      </div>
      <div class="chatF__bubble">
        <div class="chatF__dots"><span></span><span></span><span></span></div>
      </div>
    </div>
  </div>

  <!-- Input -->
  <form class="chatF__input" (ngSubmit)="sendMessage()">
    <input type="text" [(ngModel)]="aiQuery" name="aiQuery" placeholder="Pregunta lo que quieras..." [disabled]="aiLoading" autocomplete="off"/>
    <button type="submit" [disabled]="aiLoading || !aiQuery.trim()">
      <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
        <path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </form>
</div>

<!-- Botón FAB -->
<button
  class="chatF__fab"
  type="button"
  (click)="toggleChat($event)"
  [class.chatF__fab--open]="chatOpen"
>
  <i class="fa-regular fa-compass chatF__icon"></i>
</button>

</ng-container>